export default function getRegion(state) {
    return state.region;
}